import Fancybox from '~/modules/fancybox'

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'container' ]

  initialize() {
    this.element.addEventListener('turbo:before-morph-element', (event) => {
      if (event.target === this.containerTarget) {
        event.preventDefault()
      }
    })

    // The Hash plugin interferes with Turbo so we need to disable it.
    Fancybox.bind(this.element, '[data-fancybox]', {  Hash: false, Toolbar: { enabled: true }, parentEl: this.containerTarget })
  }
}
